export default "__VITE_ASSET__DOTaFod9__"